/**
 * RKH API Configuration
 * Centralized API endpoint constants
 */

export const RKH_API_CONFIG = {
    BASE_PATH: '/api/pijar/rkh',
    
    endpoints: {
        LIST: '/api/pijar/rkh',
        DETAIL: (id: string) => `/api/pijar/rkh/${id}`,
        SUMMARY: '/api/pijar/rkh/summary',
        AVAILABLE_BLOCKS: (rkhId: string) => `/api/pijar/rkh/available-blocks?rkh_id=${rkhId}`,
        // Note: query-string form is intentional per API spec
        REGISTER_LOCATIONS: (rkhId: string) => `/api/v1/pijar/rkh/${rkhId}/locations`,
    },
    
    defaults: {
        PAGE: 1,
        LIMIT: 20,
        MAX_LIMIT: 100,
    }
} as const;
